<template>
    <v-banner align="center" class="cookies-notification" v-if="showAgreement">
        <v-row no-gutters>
            <v-col
                cols="12"
                lg="10"
                md="10"
                sm="12"
                class="py-3 d-flex align-center justify-center"
            >
                <div>
                    <span class="font-weight-bold">
                        {{ $t('cookies.title') }}
                    </span>
                    <span>
                        {{ $t('cookies.description') }}
                    </span>
                    <a
                        href="https://institucional.locaweb.com.br/politicas/"
                        target="_blank"
                    >
                        {{ $t('cookies.cookies_policy') }}
                    </a>
                </div>
            </v-col>

            <v-col
                cols="12"
                lg="2"
                md="2"
                sm="12"
                class="d-flex align-center justify-center"
            >
                <v-btn class="primary elevation-0 ml-1" @click="confirm">
                    {{ $t('cookies.agreeAndClose') }}
                </v-btn>
            </v-col>
        </v-row>
    </v-banner>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data: () => {
        return {
            showAgreement: false,
        }
    },

    methods: {
        checkLgpdCookies() {
            this.$http.get('privacy-policies/cookies').then(res => {
                if (typeof res.data != 'undefined' && res.data.exists) {
                    this.$cookies.setCookie(
                        'lgpd_cookies_accepted',
                        'on',
                        365 * 3,
                    )

                    this.showAgreement = false
                } else {
                    this.showAgreement = true
                }
            })
        },

        confirm() {
            this.$http.post('privacy-policies/cookies').then(() => {
                let expireDays = this.user ? 365 * 3 : 365

                this.$cookies.setCookie(
                    'lgpd_cookies_accepted',
                    'on',
                    expireDays,
                )

                this.showAgreement = false
            })
        },
    },

    computed: {
        ...mapGetters({
            user: 'auth/user',
        }),
        acceptedCookie() {
            return this.$cookies.getCookie('lgpd_cookies_accepted')
        },
    },

    mounted() {
        if (this.user.id && !this.acceptedCookie) {
            this.checkLgpdCookies()
        } else if (!this.user && !this.acceptedCookie) {
            this.showAgreement = true
        }
    },
}
</script>

<style lang="scss" scoped>
.cookies-notification {
    bottom: 0;
    box-shadow: 0 -1px 5px #a3a3a3;
    left: 0;
    position: absolute;
    right: 0;
}
</style>
